import { RouterView } from "vue-router";
export const JoinRouting ={
  path:"/join",
  name:"join",
  meta: { title: "激活密码" },
  component: () => import(/* webpackChunkName: "join" */ "@/views/join/index.vue"),
}